import PageSwitch from '../../components/common/PageSwitch';
import { DivisionPerformance, DivisionScoreReport } from '../barratt';

/**
 * Division Scoring — a division enters its quarterly supplier scores, and the
 * score report rolls them up across divisions. One sidebar item, two tabs.
 */
export default function DivisionScoringPage() {
  return (
    <PageSwitch
      testId="division-scoring-tabs"
      tabs={[
        { value: 'scores', label: 'Enter scores', element: <DivisionPerformance /> },
        { value: 'report', label: 'Score report', element: <DivisionScoreReport /> },
      ]}
    />
  );
}
